import { toAbsoluteUrl } from "../../../../helpers";
export interface UserCountData {
  total_users: number
  active_users: number
  recent_users: number
}

interface CardsDashboardUsersProps {
  className?: string
  data?: {
    user_count?: UserCountData
  }
}
const CardsDashboardMain: React.FC<CardsDashboardUsersProps> = ({ className = '', data }) => {
  return (
    <div
      className={`card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-md-50 mb-5 mb-xl-10 ${className}`}
      style={{
        backgroundColor: "#F1416C",
        backgroundImage: `url('${toAbsoluteUrl("/media/patterns/vector-1.png")}')`,
      }}
    >
      <div className="card-header pt-5">
        <h3 className="card-title text-white fw-bold">User Overview</h3>
        <div className="card-toolbar"></div>
      </div>

      <div className="card-body pt-4">
        <div className="d-flex flex-column content-justify-center flex-row-fluid">
          {/* Total Users */}
          <div className="d-flex fw-semibold align-items-center my-3">
            <div className="text-white flex-grow-1 me-4">Total Users</div>
            <div className="fw-bolder text-white text-xxl-end">
              {data?.user_count?.total_users ?? 0}
            </div>
          </div>

          <div className="separator separator-dashed my-3"></div>

          {/* Active Users */}
          <div className="d-flex fw-semibold align-items-center my-3">
            <div className="text-white flex-grow-1 me-4">Active Users</div>
            <div className="fw-bolder text-white text-xxl-end">
              {data?.user_count?.active_users ?? 0}
            </div>
          </div>

          <div className="separator separator-dashed my-3"></div>

          {/* Recent Users */}
          <div className="d-flex fw-semibold align-items-center my-3">
            <div className="text-white flex-grow-1 me-4">Recent Users</div>
            <div className="fw-bolder text-white text-xxl-end">
              {data?.user_count?.recent_users ?? 0}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardsDashboardMain
